import "./style.less";

import defaultHeroUrl from "./assets/bookings-hero-default-02.jpg";

export default function bookingHero() {
    return {
        restrict: "E",
        scope: {
            ariaLabelPrefix: "@",
            ariaLabelSuffix: "@",
        },
        template: require("./template.html"),

        controller: function ($scope, Basket) {
            const location = Basket.getBookingLocation();

            console.log(location);

            if (!location) {
                $scope.heroImageUrl = defaultHeroUrl;
                return false;
            }

            $scope.locationName = location.Name;

            var bookingUpdateEventListener = $scope.$on(
                "booking-update-broadcast",
                function () {
                    // avail parma : bookingHero
                    $scope.heroImageUrl = ifNoHeroImageUrl(location);
                }
            );
            $scope.$on("$destroy", bookingUpdateEventListener);

            const ifNoHeroImageUrl = function (location) {
                return location.HeroImageURL.length < 5
                    ? location.HeroImageURL
                    : defaultHeroUrl;

                // if (location.heroImageUrl.length < 5) {
                //     return heroUrl;
                // } else {
                //     return heroImageUrl;
                // }
            };
            $scope.heroImageUrl = ifNoHeroImageUrl(location);
        },
    };
}
